import { lazy } from 'react';
import { ROUTE_PATHS } from '../constants/routes';

// Home pages
const Home = lazy(() => import('../pages/Home'));
const Login = lazy(() => import('../components/auth/Login'));
const Register = lazy(() => import('../components/auth/Register'));
const AccountRequest=lazy(()=>import('../components/auth/RegisterRequestForm'))
const RegistrationSuccess=lazy(()=>import('../components/auth/RegistrationSuccess'))
const VerifyOTP = lazy(() => import('../components/auth/VerifyOTP'));
const ForgetPassword = lazy(()=>import('../components/auth/ForgotPassword'));

// Dashboard pages
const MyDashboard = lazy(() => import('../dashboard/MyDashboard'));
const MyAccount = lazy(() => import('../dashboard/MyAccount'));
const MyDocuments = lazy(() => import('../dashboard/MyDocuments'));
const MyInvoice = lazy(() => import('../dashboard/MyInvoice'));
const AdditionalData = lazy(() => import('../dashboard/AdditionData'));
const ChangePassword = lazy(() => import('../dashboard/ChangePassword'));
const StatusPage =lazy(()=>import('../dashboard/StatusPage'))
const LogOut = lazy(() => import('../dashboard/LogOut'));
const ContactSupport=lazy(()=>import('../dashboard/ContactSupport'));
const EmissionCalculations=lazy(()=>import('../dashboard/EmissionCalculations'));
const Forestry=lazy(()=>import('../pages/Forestry'));
const RealTimeData =lazy(()=>import('../dashboard/RealTimeData'));
const Baseline=lazy(()=>import('../dashboard/BaselineEmissions'));

// Footer pages
const TermsAndConditions = lazy(() => import('../pages/TermsAndConditions'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
const ContactUs = lazy(() => import('../pages/ContactUs'));
const Careers = lazy(() => import('../pages/Careers'));
const CookiePolicy = lazy(() => import('../pages/CookiePolicy'));
const FAQ = lazy(() => import('../pages/FAQ'));
const GeneralTerms = lazy(() => import('../pages/GeneralTerms'));
const DataSecurity = lazy(() => import('../pages/DataSecurity'));
const InformationSecurity = lazy(() => import('../pages/InformationSecurity'));
const ResearchAndDiscovery = lazy(() => import('../pages/ResearchAndDiscovery'));
const Blogs = lazy(() => import('../pages/Blogs'));
const BlogDetail = lazy(() => import('../pages/BlogDetail'));
const ProductOverview = lazy(()=>import('../pages/Productoverviewpage'));
const OurEngagements =lazy(()=>import('../pages/OurEngagements'));
const OurLocations =lazy(()=>import('../pages/OurLocations'));
const SCMart =lazy(()=>import('../pages/SCMart'));
const Apply = lazy(()=>import('../pages/Apply'));

// Project pages
const RequestDemo = lazy(() => import('../pages/RequestDemo'));
const RenewableEnergy = lazy(() => import('../pages/RenewableEnergy'));
const WasteManagement = lazy(() => import('../pages/WasteManagement'));
const Agriculture =lazy(()=>import('../pages/Agriculture'));
const IndustrialProcess =lazy(()=>import('../pages/IndustrialProcess'));
const PlasticAlternatives = lazy(() => import('../pages/PlasticAlternatives'));
const RenewableEnergyProjects = lazy(() => import('../pages/RenewableEnergyProjects'));
const WasteManagementProjects = lazy(() => import('../pages/WasteManagementProjects'));
const PlasticAlternativeProjects = lazy(() => import('../pages/PlasticAlternativesProjects'));
const IndustrialProcessprojects =lazy(()=>import('../pages/IndustrialProcessprojects'));
const AgriculturalProjects=lazy(()=>import('../pages/AgricultureProjects'));
const ForestryProjects=lazy(()=>import('../pages/ForestryProjects'));
const ProjectVerification=lazy(()=>import('../dashboard/ProjectVerification'));
const BoundarySelectionPage=lazy(()=>import('../dashboard/AccountsTabs/Carboncredits/BoundarySelectionPage'));
//Accounts Sub Tabs
const StakeholderEngagement=lazy(()=>import('../dashboard/AccountsTabs/stakeholderengagements/StakeHolderEngagement'));
const FinancialAnalysis=lazy(()=>import('../dashboard/FinancialAnalysis'));
const carboncredits =lazy(()=>import('../dashboard/AccountsTabs/Carboncredits/CarbonCredits'));

// Financial Analysis Sub Tabs
const PLAnalysis=lazy(()=>import('../dashboard/FinancialAnalysisTabs/PLAnalysis'));
const SensitivityAnalysis=lazy(()=>import('../dashboard/FinancialAnalysisTabs/SensitivityAnalysis'));
const AditionalityAnalysis=lazy(()=>import('../dashboard/FinancialAnalysisTabs/AditionalityAnalysis'));
const ProjectReport=lazy(()=>import('../dashboard/ProjectReport'));

const ForestryDashboard =lazy(()=>import('../dashboard/Forestrydashboard'))
// Public pages
export const publicRoutes = [
   { path: ROUTE_PATHS.HOME, element: Home },
   { path: ROUTE_PATHS.BLOGS, element: Blogs },
   { path: ROUTE_PATHS.BLOG_DETAIL, element: BlogDetail },
   { path: ROUTE_PATHS.TERMS, element: TermsAndConditions },
   { path: ROUTE_PATHS.PRIVACY, element: PrivacyPolicy },
   { path: ROUTE_PATHS.CONTACT, element: ContactUs },
   { path: ROUTE_PATHS.CAREERS, element: Careers },
   { path: ROUTE_PATHS.COOKIE_POLICY, element: CookiePolicy },
   { path: ROUTE_PATHS.FAQ, element: FAQ },
   { path: ROUTE_PATHS.GENERAL_TERMS, element: GeneralTerms },
   { path: ROUTE_PATHS.DATA_SECURITY, element: DataSecurity },
   { path: ROUTE_PATHS.INFORMATION_SECURITY, element: InformationSecurity },
   { path: ROUTE_PATHS.RESEARCH, element: ResearchAndDiscovery },
   { path: ROUTE_PATHS.REQUEST_DEMO, element: RequestDemo },
   { path: ROUTE_PATHS.RENEWABLE_ENERGY, element: RenewableEnergy },
   { path: ROUTE_PATHS.WASTE_MANAGEMENT, element: WasteManagement },
   { path: ROUTE_PATHS.PLASTIC_ALTERNATIVES, element: PlasticAlternatives },
   { path: ROUTE_PATHS.RENEWABLE_PROJECTS, element: RenewableEnergyProjects },
   { path: ROUTE_PATHS.WASTE_PROJECTS, element: WasteManagementProjects },
   { path: ROUTE_PATHS.PLASTIC_PROJECTS, element: PlasticAlternativeProjects },
   {path: ROUTE_PATHS.APPLY,element:Apply},
   {path:ROUTE_PATHS.SCMart,element:SCMart},
   {path: ROUTE_PATHS.ProductOverview, element:ProductOverview},
   {path:ROUTE_PATHS.Agriculture,element:Agriculture},
   {path:ROUTE_PATHS.IndustrialProcess,element:IndustrialProcess},
   {path:ROUTE_PATHS.AgriculturalProjects,element:AgriculturalProjects},
   {path:ROUTE_PATHS.IndustrialProcessprojects,element:IndustrialProcessprojects},
   {path:ROUTE_PATHS.Forestry,element:Forestry},
   {path:ROUTE_PATHS.ForestryProjects,element:ForestryProjects},
   {path:ROUTE_PATHS.OurEngagements,element:OurEngagements},
   {path:ROUTE_PATHS.OurLocations,element:OurLocations},
   {path:ROUTE_PATHS.BoundarySelectionPage,element:BoundarySelectionPage},
   {path:ROUTE_PATHS.ForestryDashboard,element:ForestryDashboard}

];
export const authRoutes = [
   { path: ROUTE_PATHS.LOGIN, element: Login, isLoginPage: true },
   { path: ROUTE_PATHS.REGISTER, element: Register, isLoginPage: true },
   { path: ROUTE_PATHS.VERIFY_OTP, element: VerifyOTP, isLoginPage: true },
   {path: ROUTE_PATHS.AccountRequest,element:AccountRequest,isLoginPage:true},
   {path:ROUTE_PATHS.RegistrationSuccess, element:RegistrationSuccess,isLoginPage:true},
   {path:ROUTE_PATHS.ForgetPassword,element:ForgetPassword,isLoginPage:true},

];

export const protectedRoutes = [
   { path: ROUTE_PATHS.DASHBOARD, element: MyDashboard },
   { path: ROUTE_PATHS.ACCOUNT, element: MyAccount },
   { path: ROUTE_PATHS.DOCUMENTS, element: MyDocuments },
   { path: ROUTE_PATHS.INVOICE, element: MyInvoice },
   { path: ROUTE_PATHS.StatusPage,element:StatusPage},
   { path: ROUTE_PATHS.ADDITIONAL_DATA, element: AdditionalData },
   { path: ROUTE_PATHS.CHANGE_PASSWORD, element: ChangePassword },
   { path: ROUTE_PATHS.LOGOUT, element: LogOut },
   { path: ROUTE_PATHS.LOGOUT_ALL, element: LogOut },
   { path: ROUTE_PATHS.ContactSupport,element:ContactSupport},
   {path :ROUTE_PATHS.RealTimeData,element:RealTimeData},
   { path: ROUTE_PATHS.Baseline, element: Baseline },
   //Account Sub Tab Routes
   {path: ROUTE_PATHS.StakeholderEngagement,element:StakeholderEngagement},
   {path:ROUTE_PATHS.FinancialAnalysis,element:FinancialAnalysis},
   {path:ROUTE_PATHS.carboncredits,element:carboncredits},
   {path:ROUTE_PATHS.EmissionCalculations,element:EmissionCalculations},
   {path:ROUTE_PATHS.ProjectReport,element:ProjectReport},
   {path:ROUTE_PATHS.ProjectVerification,element:ProjectVerification},

   //Financial Analysis Sub Tabs
   {path:ROUTE_PATHS.PLAnalysis,element:PLAnalysis},
   {path:ROUTE_PATHS.SensitivityAnalysis,element:SensitivityAnalysis},
   {path:ROUTE_PATHS.AditionalityAnalysis,element:AditionalityAnalysis},
];

export const NotFound = () => (
   <div className="flex items-center justify-center min-h-screen md:text-xl lg:text-3xl">
      404 | Not Found
   </div>
);